{
  "common": {
    "memberCenter": "ศูนย์สมาชิก",
    "points": "คะแนน",
    "level": "ระดับ",
    "coupons": "คูปอง",
    "checkin": "เช็คอิน",
    "history": "ประวัติ",
    "balance": "ยอดคงเหลือ",
    "expire": "หมดอายุ",
    "confirm": "ยืนยัน",
    "cancel": "ยกเลิก",
    "loading": "กำลังโหลด...",
    "noData": "ไม่มีข้อมูล",
    "retry": "ลองอีกครั้ง",
    "success": "สำเร็จ",
    "failed": "ล้มเหลว"
  },
  "points": {
    "earn": "ได้รับ {amount} คะแนน",
    "spend": "ใช้ {amount} คะแนน",
    "balance": "ยอดคงเหลือปัจจุบัน: {amount} คะแนน",
    "expired": "{amount} คะแนนหมดอายุแล้ว",
    "estimated": "ประมาณการ (รอการยืนยัน)"
  },
  "level": {
    "current": "ระดับปัจจุบัน: {name}",
    "nextLevel": "ระดับถัดไป: {name}",
    "progress": "{current}/{target} สู่ระดับถัดไป",
    "upgraded": "ยินดีด้วย! เลื่อนระดับเป็น {name}"
  },
  "coupon": {
    "claim": "รับ",
    "claimed": "รับแล้ว",
    "expired": "หมดอายุ",
    "used": "ใช้แล้ว",
    "validUntil": "ใช้ได้ถึง {date}"
  },
  "checkin": {
    "today": "เช็คอินวันนี้",
    "done": "เช็คอินแล้ว",
    "streak": "เช็คอินติดต่อกัน {days} วัน",
    "reward": "+{amount} คะแนน"
  },
  "errors": {
    "network": "เกิดข้อผิดพลาดเครือข่าย กรุณาลองอีกครั้ง",
    "unauthorized": "กรุณาเข้าสู่ระบบ",
    "serverError": "เกิดข้อผิดพลาดเซิร์ฟเวอร์ กรุณาลองอีกครั้งในภายหลัง",
    "timeout": "คำขอหมดเวลา"
  },
  "ui": {
    "memberCenter": {
      "loading": "กำลังโหลด...",
      "avatarAlt": "รูปสมาชิก",
      "pointsBalance": "คะแนนของฉัน",
      "menuLabel": "เมนูสมาชิก",
      "menu": {
        "pointsDetail": "ประวัติคะแนน",
        "levelDetail": "สิทธิประโยชน์ระดับ",
        "coupons": "คูปองของฉัน",
        "referral": "เชิญเพื่อน",
        "checkin": "เช็คอินรายวัน"
      }
    },
    "pointsDetail": {
      "title": "ประวัติคะแนน",
      "empty": "ไม่มีประวัติคะแนน",
      "loading": "กำลังโหลด...",
      "noMore": "ไม่มีรายการเพิ่มเติม",
      "listLabel": "รายการคะแนน",
      "status": {
        "pending": "รอดำเนินการ",
        "active": "ใช้งานได้",
        "used": "ใช้แล้ว",
        "expired": "หมดอายุ"
      }
    },
    "levelProgress": {
      "loading": "กำลังโหลด...",
      "maxLevel": "ระดับสูงสุดแล้ว",
      "progressLabel": "ความคืบหน้าระดับ",
      "noBenefits": "ยังไม่มีสิทธิประโยชน์",
      "nextLevel": "ระดับถัดไป: {name}",
      "benefitsTitle": "สิทธิประโยชน์ของฉัน"
    },
    "couponList": {
      "title": "คูปองของฉัน",
      "tabsLabel": "หมวดหมู่คูปอง",
      "listLabel": "รายการคูปอง",
      "empty": "ไม่มีคูปอง",
      "freeShipping": "ส่งฟรี",
      "giftValue": "ของขวัญ",
      "discountValue": "ลด {value}%",
      "type": {
        "discount": "ส่วนลด",
        "cash": "เงินสด",
        "shipping": "ค่าจัดส่ง",
        "gift": "ของขวัญ"
      },
      "tab": {
        "available": "ใช้ได้",
        "used": "ใช้แล้ว",
        "expired": "หมดอายุ",
        "claimable": "รับ"
      },
      "loadingClaimable": "กำลังโหลด...",
      "noClaimable": "ไม่มีคูปองที่รับได้",
      "claiming": "กำลังรับ...",
      "claim": "รับ",
      "stockInfo": "เหลือ {remaining}",
      "stockUnlimited": "ไม่จำกัด",
      "minOrder": "ขั้นต่ำ {amount}"
    },
    "referralShare": {
      "loading": "กำลังโหลด...",
      "title": "เชิญเพื่อน",
      "shareTitle": "เชิญบคะแนน",
      "shareText": "สมัครเลยและรับของขวัญฟรี!",
      "invitedCount": "เชิญแล้ว",
      "rewardPoints": "คะแนนที่ได้รับ",
      "codeLabel": "รหัสเชิญของฉัน",
      "linkLabel": "ลิงก์เชิญ",
      "copy": "คัดลอก",
      "copyCode": "คัดลอกรหัสเชิญ",
      "share": "แชร์",
      "rewardHint": "รับ {points} คะแนนต่อเพื่อนหนึ่งคน",
      "tabShare": "เชิญ",
      "tabRecords": "ประวัติ",
      "loadingRecords": "กำลังโหลด...",
      "noRecords": "ยังไม่มีการเชิญ",
      "anonymousUser": "ผู้ใช้ไม่ระบุชื่อ",
      "prevPage": "ก่อนหน้า",
      "nextPage": "ถัดไป",
      "recordsLabel": "รายการเชิญ",
      "status": {
        "registered": "ลงทะเบียนแล้ว",
        "first_order": "สั่งซื้อครั้งแรก",
        "rewarded": "ได้รับรางวัล"
      }
    },
    "checkinCalendar": {
      "loading": "กำลังโหลด...",
      "checking": "กำลังเช็คอิน...",
      "checkin": "เช็คอิน",
      "alreadyChecked": "เช็คอินแล้ววันนี้",
      "day": "{count} วัน",
      "title": "เช็คอินรายวัน",
      "streak": "เช็คอินติดต่อกัน {days} วัน",
      "calendarLabel": "ปฏิทินเช็คอิน",
      "rewardsTitle": "รางวัลต่อเนื่อง",
      "rewardsLabel": "รายการรางวัล",
      "weekday": {
        "sun": "อา",
        "mon": "จ",
        "tue": "อ",
        "wed": "พ",
        "thu": "พฤ",
        "fri": "ศ",
        "sat": "ส"
      },
      "prevMonth": "เดือนก่อน",
      "nextMonth": "เดือนถัดไป",
      "monthDays": "เช็คอินเดือนนี้ {count} วัน",
      "monthPoints": "คะแนนเดือนนี้"
    },
    "orderList": {
      "loading": "กำลังโหลดคำสั่งซื้อ...",
      "title": "ประวัติคำสั่งซื้อ",
      "noOrders": "ยังไม่มีคำสั่งซื้อ",
      "listLabel": "รายการคำสั่งซื้อ",
      "prevPage": "ก่อนหน้า",
      "nextPage": "ถัดไป",
      "typePoints": "คะแนน",
      "typeGrowth": "ค่าเติบโต",
      "bizType": {
        "Order_Pay": "ชำระเงินคำสั่งซื้อ",
        "Order_Refund": "คืนเงินคำสั่งซื้อ"
      },
      "status": {
        "pending": "รอดำเนินการ",
        "active": "เข้าบัญชีแล้ว",
        "invalid": "ไม่ถูกต้อง",
        "used": "ใช้แล้ว",
        "expired": "หมดอายุ"
      }
    },
    "addressManager": {
      "title": "ที่อยู่ของฉัน",
      "add": "เพิ่มที่อยู่",
      "empty": "ยังไม่มีที่อยู่",
      "default": "ค่าเริ่มต้น",
      "setDefault": "ตั้งเป็นค่าเริ่มต้น",
      "edit": "แก้ไข",
      "delete": "ลบ"
    },
    "accountSettings": {
      "title": "ตั้งค่าบัญชี",
      "dataExport": {
        "title": "ส่งออกข้อมูล",
        "desc": "ดาวน์โหลดสำเนาข้อมูลส่วนตัว",
        "button": "ขอส่งออก",
        "processing": "กำลังดำเนินการ..."
      },
      "deleteAccount": {
        "title": "ลบบัญชี",
        "desc": "ลบบัญชีและข้อมูลทั้งหมดอย่างถาวร",
        "button": "ลบบัญชี",
        "confirm": "การดำเนินการนี้ไม่สามารถย้อนกลับได้ ข้อมูลทั้งหมดจะถูกลบอย่างถาวร",
        "confirmButton": "ใช่ ลบบัญชี",
        "cancel": "ยกเลิก"
      }
    },
    "checkout": {
      "points": {
        "title": "หักคะแนน",
        "unit": "คะแนน",
        "available": "ใช้ได้",
        "deduct": "หัก"
      },
      "coupon": {
        "title": "คูปอง",
        "none": "ไม่ใช้คูปอง"
      },
      "summary": {
        "order": "ยอดสั่งซื้อ",
        "discount": "ส่วนลด",
        "total": "ชำระ"
      }
    },
    "profile": {
      "form": {
        "nickname": "ชื่อเล่น",
        "avatar": "URL รูปโปรไฟล์",
        "locale": "ภาษา",
        "save": "บันทึก",
        "saving": "กำลังบันทึก..."
      }
    },
    "auth": {
      "login": {
        "emailLabel": "อีเมล",
        "passwordLabel": "รหัสผ่าน",
        "submit": "เข้าสู่ระบบ",
        "createAccount": "สร้างบัญชี",
        "forgotPassword": "ลืมรหัสผ่าน?",
        "orDivider": "หรือ"
      },
      "register": {
        "emailLabel": "อีเมล",
        "passwordLabel": "รหัสผ่าน",
        "confirmPasswordLabel": "ยืนยันรหัสผ่าน",
        "passwordHint": "อย่างน้อย 8 ตัวอักษร ประกอบด้วยตัวอักษรและตัวเลข",
        "submit": "สร้างบัญชี",
        "hasAccount": "มีบัญชีแล้ว? เข้าสู่ระบบ",
        "passwordMismatch": "รหัสผ่านไม่ตรงกัน",
        "submitting": "กำลังสร้าง..."
      },
      "oauth": {
        "continueWith": "ดำเนินการต่อด้วย {provider}"
      },
      "verify": {
        "title": "ยืนยันอีเมลของคุณ",
        "description": "เราได้ส่งรหัสยืนยันไปที่ {email}",
        "digitLabel": "หลักที่ {index}",
        "resend": "ส่งรหัสอีกครั้ง",
        "resendCountdown": "ส่งอีกครั้ง ({countdown} วินาที)",
        "backToRegister": "กลับไปลงทะเบียน"
      },
      "forgot": {
        "title": "รีเซ็ตรหัสผ่าน",
        "description": "กรอกอีเมลของคุณ แล้วเราจะส่งรหัสยืนยันให้คุณ",
        "emailLabel": "อีเมล",
        "submit": "ส่งรหัส",
        "backToLogin": "กลับไปเข้าสู่ระบบ"
      }
    }
  },
  "sdk": {
    "error": {
      "210900": "พารามิเตอร์ไม่ถูกต้อง",
      "210901": "ต้องระบุรหัสผู้เช่า",
      "210902": "คำขอมากเกินไป กรุณาลองใหม่ภายหลัง",
      "210903": "ไม่ได้รับอนุญาต",
      "210904": "โทเค็นหมดอายุ",
      "210905": "โทเค็นไม่ถูกต้อง",
      "210906": "การรีเฟรชโทเค็นล้มเหลว",
      "210907": "การแลกเปลี่ยนโทเค็นแพลตฟอร์มล้มเหลว",
      "210908": "รีเฟรชโทเค็นไม่ถูกต้อง",
      "210909": "รีเฟรชโทเค็นหมดอายุ",
      "210911": "ไม่พบสมาชิก",
      "210912": "ไม่พบข้อมูลระดับ",
      "210920": "อีเมลนี้ถูกลงทะเบียนแล้ว",
      "210921": "รหัสผ่านอ่อนแอเกินไป: ต้องมีอย่างน้อย 8 ตัวอักษร ประกอบด้วยตัวอักษรและตัวเลข",
      "210922": "ส่งรหัสยืนยันบ่อยเกินไป กรุณาลองใหม่ภายหลัง",
      "210923": "รหัสยืนยันไม่ถูกต้องหรือหมดอายุ",
      "210924": "ข้อมูลการลงทะเบียนหมดอายุ กรุณาลงทะเบียนใหม่",
      "210925": "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
      "210926": "อีเมลยังไม่ได้ยืนยัน กรุณายืนยันก่อน",
      "210927": "การยืนยันตัวตน OAuth ล้มเหลว",
      "210928": "สถานะ OAuth ไม่ถูกต้องหรือหมดอายุ",
      "210929": "วิธีการเข้าสู่ระบบไม่รองรับ",
      "210930": "การสร้างผู้ใช้ล้มเหลว",
      "210931": "การคำนวณส่วนลดล้มเหลว",
      "210951": "การสอบถามยอดคะแนนล้มเหลว",
      "210952": "การสอบถามธุรกรรมคะแนนล้มเหลว",
      "210953": "การสะสมคะแนนล้มเหลว",
      "210954": "การเปิดใช้งานคะแนนล้มเหลว",
      "210955": "การใช้คะแนนล้มเหลว",
      "210956": "ยอดคะแนนไม่เพียงพอ",
      "210957": "ไม่พบบัญชีคะแนน",
      "210958": "สถานะคะแนนไม่อนุญาตให้ดำเนินการนี้",
      "210971": "คูปองหมด",
      "210972": "คูปองถูกรับไปแล้ว",
      "210981": "การเขียนคิวข้อความล้มเหลว",
      "210982": "การซิงค์บริการภายในล้มเหลว",
      "210983": "ไม่พบสินค้าแลกเปลี่ยน",
      "210984": "การแลกเปลี่ยนล้มเหลว",
      "210985": "ไม่พบรหัสแนะนำ",
      "210986": "การผูกการแนะนำล้มเหลว",
      "210987": "ไม่พบผู้แนะนำ",
      "210988": "ไม่สามารถเชิญตัวเองได้",
      "210989": "การรับคูปองล้มเหลว",
      "210990": "เช็คอินแล้ววันนี้",
      "210991": "การเช็คอินล้มเหลว",
      "211001": "การตรวจสอบลายเซ็น webhook ล้มเหลว",
      "211002": "แพลตฟอร์ม webhook ไม่รองรับ",
      "211003": "คำขอ webhook ซ้ำ",
      "211004": "ยังไม่ได้กำหนดค่า secret ของ webhook",
      "211005": "เวลา webhook หมดอายุ",
      "211900": "ดำเนินการล้มเหลว กรุณาลองใหม่",
      "211901": "การยืนยันตัวตนล้มเหลว",
      "211902": "บัญชีไม่ได้ผูก",
      "211903": "การเข้าถึงถูกปฏิเสธ",
      "211904": "ไม่พบการกำหนดค่า",
      "211905": "ขอบเขตการกำหนดค่าไม่ถูกต้อง",
      "211906": "ไม่พบบทบาท",
      "211907": "บทบาทระบบไม่สามารถลบได้",
      "211908": "ไม่มีสิทธิ์เข้าถึงผู้เช่านี้",
      "211909": "การตรวจสอบล้มเหลว",
      "211910": "ไม่พบทรัพยากร",
      "211911": "ไม่พบสมาชิก",
      "211912": "ข้อมูลประจำตัวขัดแย้ง กรุณาติดต่อฝ่ายสนับสนุน",
      "211913": "การเปิดใช้งานบัญชีเงาล้มเหลว",
      "211914": "ไม่พบบันทึกการตรวจสอบ",
      "211915": "สถานะบันทึกการตรวจสอบไม่ใช่รอดำเนินการ",
      "211916": "ไม่พบ OneID",
      "211917": "การยกเลิกการเชื่อมโยง OneID ล้มเหลว",
      "211931": "ไม่พบการกำหนดค่าระดับ",
      "211932": "ระดับมีสมาชิกที่เกี่ยวข้อง ไม่สามารถลบได้",
      "211933": "การตรวจสอบเงื่อนไขการอัปเกรดระดับล้มเหลว",
      "211934": "ลำดับระดับต้องต่อเนื่อง",
      "211951": "การเปลี่ยนสถานะบัญชีไม่ถูกต้อง",
      "211952": "ยอดคะแนนไม่เพียงพอ",
      "211953": "ไม่พบบันทึกบัญชี",
      "211954": "ธุรกรรมคะแนนซ้ำ",
      "211955": "จำนวนคะแนนไม่ถูกต้อง",
      "211956": "การหักคะแนนเกินอัตราส่วนสูงสุด",
      "211957": "คะแนนต่ำกว่าเกณฑ์ขั้นต่ำ",
      "211958": "ยังไม่ได้กำหนดค่ากฎการสะสมคะแนน",
      "211959": "การเปิดใช้งานคะแนนล้มเหลว: สถานะไม่ใช่รอดำเนินการ",
      "211960": "การเข้าถึงธุรกรรมคะแนนถูกปฏิเสธ",
      "211961": "คะแนนหมดอายุแล้ว",
      "211962": "ยังไม่ได้กำหนดค่ากฎการเติบโต",
      "211971": "ไม่พบเทมเพลตคูปอง",
      "211972": "สถานะเทมเพลตคูปองไม่ถูกต้อง",
      "211973": "เกินขีดจำกัดคูปองต่อผู้ใช้",
      "211974": "เกินโควตาคูปองทั้งหมด",
      "211975": "สถานะการใช้คูปองไม่ถูกต้อง",
      "211976": "คูปองหมดอายุ",
      "211977": "เทมเพลตคูปองมีคูปองที่ออกแล้ว ไม่สามารถลบได้",
      "211981": "ไม่พบงานการแจ้งเตือน",
      "211982": "สถานะงานการแจ้งเตือนไม่อนุญาตให้แก้ไข",
      "211983": "สถานะงานการแจ้งเตือนไม่อนุญาตให้ยกเลิก",
      "211984": "ไม่พบเทมเพลตการแจ้งเตือน",
      "211985": "กลุ่มเป้าหมายการแจ้งเตือนว่างเปล่า",
      "211991": "บริการไม่ว่าง กรุณาลองใหม่ภายหลัง",
      "211992": "การเผยแพร่ข้อความล้มเหลว",
      "211993": "ข้อความเข้าคิวข้อความตาย",
      "network": "เกิดข้อผิดพลาดของเครือข่าย กรุณาตรวจสอบการเชื่อมต่อ",
      "timeout": "หมดเวลาคำขอ กรุณาลองใหม่",
      "aborted": "คำขอถูกยกเลิก",
      "parse": "เกิดข้อผิดพลาดในการแยกวิเคราะห์การตอบกลับ",
      "unauthorized": "กรุณาเข้าสู่ระบบก่อน",
      "config": "เกิดข้อผิดพลาดในการเริ่มต้น SDK",
      "unknown": "เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ"
    }
  },
  "exchange": {
    "store": {
      "title": "แลกคะแนน",
      "myOrders": "รายการแลก",
      "empty": "ไม่มีสินค้าที่แลกได้",
      "points": "คะแนน",
      "stock": "คงเหลือ",
      "back": "กลับ",
      "redeem": "แลก",
      "soldOut": "หมด",
      "noOrders": "ยังไม่มีรายการแลก",
      "status": {
        "pending": "รอจัดส่ง",
        "completed": "สำเร็จ",
        "cancelled": "ยกเลิก"
      }
    }
  },
  "message": {
    "center": {
      "title": "ข้อความ",
      "empty": "ไม่มีข้อความ"
    },
    "type": {
      "system": "ระบบ",
      "marketing": "โปรโมชั่น",
      "transaction": "ธุรกรรม",
      "activity": "กิจกรรม"
    }
  }
}
